import {BlockEmbed} from './block';

class Toc extends BlockEmbed {}
Toc.blotName = 'toc';
Toc.tagName = 'hr';
Toc.className = 'toc';

export default Toc;